module.exports = __webpack_public_path__ + "static/img/wait.df33531.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/example02/wait.gif
// module id = 8y64
// module chunks = 1